"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProgressMonitorKind_1 = require("../../core/model/ProgressMonitorKind"); //tslint:disable:max-classes-per-file

/**
 * <p>Distinguishes monitors related to CSV file upload related to a {@link PriceTerminationUpload}.</p>
 *
 * @author JMe
 */


var PriceTerminationUploadMonitor =
/*#__PURE__*/
function (_ProgressMonitorKind_) {
  _inherits(PriceTerminationUploadMonitor, _ProgressMonitorKind_);

  function PriceTerminationUploadMonitor() {
    _classCallCheck(this, PriceTerminationUploadMonitor);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceTerminationUploadMonitor).apply(this, arguments));
  }

  _createClass(PriceTerminationUploadMonitor, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }]);

  return PriceTerminationUploadMonitor;
}(ProgressMonitorKind_1.ProgressMonitorKind);

exports.PriceTerminationUploadMonitor = PriceTerminationUploadMonitor;
PriceTerminationUploadMonitor.TAG = ProgressMonitorKind_1.ProgressMonitorKind.register(PriceTerminationUploadMonitor);
/**
 * <p>Enumerates main phases of uploading source data related to termination of sellout/regular prices. A phase should be taken into account
 * while monitoring the uploading progress. Each phase should have different weight within the process.</p>
 *
 * @author JMe
 */

var PriceTerminationUploadPhaseEnum;

(function (PriceTerminationUploadPhaseEnum) {
  /**
   * Checks, that header of input file is correct.
   * <br/>
   * Suggested weight: low.
   */
  PriceTerminationUploadPhaseEnum["DataStructureCheck"] = "DATA_STRUCTURE_CHECK";
  /**
   * Checks, that all rows contains required attributes. Checked while parsing CSV to a {@link PriceTerminationUploadedItem}.
   * <br/>
   * Suggested weight: low.
   */

  PriceTerminationUploadPhaseEnum["DataRequiredAttributesCheck"] = "DATA_REQUIRED_ATTRIBUTES_CHECK";
  /**
   * Transforms CSV rows to a {@link PriceTerminationUploadedItem}.
   * <br/>
   * Suggested weight: medium.
   */

  PriceTerminationUploadPhaseEnum["DataRawRowsImport"] = "DATA_RAW_ROWS_IMPORT";
  /**
   * Validates transformed {@link PriceTerminationUploadedItem}, last phase during which uploading process still may be aborted.
   * <br/>
   * Suggested weight: high.
   */

  PriceTerminationUploadPhaseEnum["DataRowsValidation"] = "DATA_ROWS_VALIDATION";
  /**
   * Transforms uploaded {@link PriceTerminationUploadedItem} to a {@link PriceTerminationItem} and creates a {@link PriceTermination}.
   * <br/>
   * Suggested weight: high.
   */

  PriceTerminationUploadPhaseEnum["DataRawRowsTransformation"] = "DATA_ROWS_TRANSFORMATION";
  /**
   * Final step, {@link PriceTermination} is associated with {@link PriceTerminationUpload} and progress is finished.
   * <br/>
   * Suggested weight: medium.
   */

  PriceTerminationUploadPhaseEnum["DataTerminationOverviewAssigned"] = "DATA_TERMINATION_OVERVIEW_ASSIGNED";
})(PriceTerminationUploadPhaseEnum = exports.PriceTerminationUploadPhaseEnum || (exports.PriceTerminationUploadPhaseEnum = {}));
/**
 * <p>Default implementation of {@link PriceTerminationUploadPhaseWeights}.</p>
 *
 * <p><b>Currently there is only one implementation which is common to termination of regular/sellout prices.</b></p>
 *
 * @author JMe
 */


exports.PRICES_TERMINATION_UPLOAD_PHASE_WEIGHTS = immutable_1.Map([[PriceTerminationUploadPhaseEnum.DataStructureCheck, 1], [PriceTerminationUploadPhaseEnum.DataRequiredAttributesCheck, 1], [PriceTerminationUploadPhaseEnum.DataRawRowsImport, 5], [PriceTerminationUploadPhaseEnum.DataRowsValidation, 5], [PriceTerminationUploadPhaseEnum.DataRawRowsTransformation, 10], [PriceTerminationUploadPhaseEnum.DataTerminationOverviewAssigned, 5]]);
/**
 * <p>Upload summary of data related to a {@link PriceTermination}.</p>
 *
 * <p><b>If the uploaded file does not fulfill basic conditions such as file data format, data structure, etc., there should not be created
 * any associated {@link PriceTerminationUploadedItem} related to the upload.</b></p>
 *
 * @author JMe
 * @author Jaroslav Sevcik
 */

var PriceTerminationUpload =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceTerminationUpload, _DomainObject_1$Domai);

  /**
   * @param id
   * @param name The name of the upload.
   * @param issued The moment the upload process was issued.
   * @param progressId The identification of upload processing (validations and such). Client should query the progress state until the
   *        process is in the final state.
   * @param terminationId Corresponds to {@link PriceTermination.id}. Filled in case there are no crucial errors within upload file.
   *        If filled, client should fetch for {@link PriceTermination} (or directly for {@link SiteReleaseTerminationItem items}) and
   *        redirect user to detail page.
   * @param validation Validation result of upload. You should use this result to recognize if the validation contains some errors or not.
   *        May aggregate summary info in case of errors within some uploaded items.
   */
  function PriceTerminationUpload(id, name, issued, progressId, terminationId, validation) {
    var _this;

    _classCallCheck(this, PriceTerminationUpload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceTerminationUpload).call(this));
    _this.id = id;
    _this.name = name;
    _this.issued = issued;
    _this.progressId = progressId;
    _this.terminationId = terminationId;
    _this.validation = validation;
    return _this;
  }

  return PriceTerminationUpload;
}(DomainObject_1.DomainObject);

exports.PriceTerminationUpload = PriceTerminationUpload;